const en = [
  {
    page: "COMPANY",
    url: [
      "Company introduction",
      "CEO Greeting",
      "History and organization",
      "Sustainable management",
      "License status",
      "Major customers",
      "Location",
    ]
  },
  {
    page: "BUSINESS",
    url: [
      "Food processing equipment",
      "Industrial robot system",
      "Sensor monitoring system",
      "AGIPU mixing system",
    ]
  },
  {
    page: "PRODUCTS",
    url: [
      "Accessories for food production processes",
      "AGIPU Mixing system accessory",
      "Robots & Accessory",
      "Sensor accessory"
    ]
  },
  {
    page: "R&D CENTER",
    url: [
      "R&D CENTER",
      "Robot development",
      "Sensor development"
    ]
  },
  {
    page: "RECRUIT",
    url : ["RECRUIT"]
  },
]

const ru = [
  {
    page: "Компания",
    url: [
      "Представление компании",
      "Приветствие",
      "История и организация",
      "Sustainable management",
      "Устойчивое управление",
      "Основные клиенты",
      "Место проведения",
    ]
  },
  {
    page: "Бизнес",
    url: [
      "Оборудование для пищевой промышленности",
      "Промышленная робототехника",
      "Система мониторинга датчиков",
      "Система смешивания AGIPU",
    ]
  },
  {
    page: "Продукты",
    url: [
      "Аксессуары для пищевых процессов",
      "Роботы и аксессуары",
      "Сенсорный аксессуары",
      "АГИПУ Смешивание оборудования"
    ]
  },
  {
    page: "НИОКР центр",
    url: [
      "Разработка роботов",
      "Разработка датчиков",
      "Разработка гидравлических приборов"
    ]
  },
  {
    page: "РЕКРУИТ",
    url : ["РЕКРУИТ"]
  },
]

const Hindi = [
  {
    page: "कंपनी",
    url: [
      "कम्पन्या परिचय",
      "सीओओ अभिवादन",
      "इतिहास और संगठन",
      "सक्षम प्रबंधन",
      "लिसेंस स्थिति",
      "मुख्य ग्राहक",
      "स्थान",
    ]
  },
  {
    page: "व्यवसाय",
    url: [
      " खाद्य प्रसंस्करण उपकरण",
      " औद्योगिक रोबोट प्रणाली",
      "सेंसर मॉनिटरिंग सिस्टम",
      "AGIPU मिश्रण प्रणाली",
    ]
  },
  {
    page: "उत्पाद",
    url: [
      " खाद्य उत्पादन प्रक्रियाओं के लिए एक्सेसरी",
      "AGIPU मिश्रण तंत्र सहायक",
      "रोबॉट्स एंड एक्सेसररी",
      " सेंसर सहायक"
    ]
  },
  {
    page: "अनुसंधान केंद्र",
    url: [
      "अनुसंधान एवं विकास CENTER",
      "रोबोट विकास",
      "संवेदक विकास"
    ]
  },
  {
    page: "रिक्रयूइट",
    url : ["रिक्रयूइट"]
  },
]

export { en, ru, Hindi };